export const customerStatusFunc = async (
  data: any,
  query: Function,
  type?: string
) => {
  const promises = data.map(async (item: any) => {
    if (item?.patternId === '') return

    try {
      const response = await query({
        variables: {
          val: { name: item?.patternId },
        },
      })

      if (!response || !response?.data) {
        console.error('응답된 데이터가 없습니다')
        return
      }

      return {
        data: Object.values(response?.data)[0] || [], // 데이터가 없는 경우 빈 배열로 처리
        months: item?.months,
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      return
    }
  })

  const results = await Promise.all(promises)

  if (results?.length === 0 || results[0] === undefined) return

  const filteredResults = results.map((result) => {
    // months 배열을 문자열 형태로 변환 (예: 1 -> '01')
    const stringMonths = result?.months?.map((month: any) =>
      month.toString().padStart(2, '0')
    )

    const filteredData = result?.data?.filter((data: any) => {
      // 'YYYYMMDD'에서 월 추출 (문자열로 유지)
      const monthOfData = data?.dt?.substring(4, 6)
      return stringMonths?.includes(monthOfData)
    })

    return filteredData
  })

  const flattenedResults = filteredResults?.flat()

  const transformedData = flattenedResults?.map((v: any) => {
    const formattedDate = `${v?.dt?.substring(0, 4)}-${v?.dt?.substring(4, 6)}-${v?.dt?.substring(6, 8)}T${v?.hr?.toString().padStart(2, '0')}:00:00`

    if (type === 'load') {
      return {
        date: formattedDate,
        value: v?.usage_power as number,
      }
    } else {
      return {
        date: formattedDate,
        value: v?.generate_power as number,
      }
    }
  })

  return transformedData
}
